/* eslint-disable import/no-extraneous-dependencies,  no-plusplus */
import { ClientMessageRecord } from '@tassat/payments-definitions';
import { ActionTypes } from '@tassat/ui-definitions';
import moment from 'moment';

import { IErrorValues, IFormValues } from './types';
import { formatMomentDateTime } from '../helpers/stringHelpers';
import { validateRichText } from '../helpers/validationHelpers';

const validationMessageDateFormat = 'MMM DD YYYY hh:mm:ss A';

export const validateClientMessage = (values: IFormValues, initialValues: IFormValues, opts: {
    actionType: ActionTypes;
    editMessage?: ClientMessageRecord;
    validationMessages: ClientMessageRecord[];
}) => {
    const {
        actionType,
        editMessage,
        validationMessages
    } = opts;

    const errors = {} as IErrorValues;
    const now = moment();
    const startDate = moment(values.StartAt);
    const endDate = moment(values.EndAt);

    if (!values.ClientMsgType || values.ClientMsgType === -1) {
        errors.ClientMsgType = 'Required';
    }

    const richTextError = validateRichText(values.Message);
    if (!values.Message) {
        errors.Message = 'Required';
    } else if (richTextError) {
        errors.Message = richTextError;
    }

    if (!values.StartAt) {
        errors.StartAt = 'Required';
    } else if (!startDate.isValid()) {
        errors.StartAt = 'Invalid date/time';
    }

    if (!values.EndAt) {
        errors.EndAt = 'Required';
    } else if (!endDate.isValid()) {
        errors.EndAt = 'Invalid date/time';
    } else if (endDate.valueOf() <= now.valueOf()) {
        errors.EndAt = 'End date/time cannot be before current time';
    } else if (endDate.valueOf() <= startDate.valueOf()) {
        errors.EndAt = 'End date/time must be greater than Start date/time';
    }

    if (!errors.ClientMsgType && values.StartAt && !errors.StartAt) {
        const filteredMessages = validationMessages.filter((message) => message.ClientMsgType ===
            Number(values.ClientMsgType) &&
            (
                actionType === ActionTypes.add ||
                (actionType === ActionTypes.edit && editMessage?.MessageId !== message.MessageId)));

        for (let i = 0; i < filteredMessages.length; i++) {
            const message = filteredMessages[i];
            const messageStart = moment.unix(Number(message.StartAt) / 1000);
            const messageEnd = moment.unix(Number(message.EndAt) / 1000);

            if (startDate.valueOf() >= messageStart.valueOf() && startDate.valueOf() <= messageEnd.valueOf()) {
                errors.StartAt = `
                    Start time falls within another message. Next available start time would be after
                    ${formatMomentDateTime(messageEnd, validationMessageDateFormat)}`;
                break;
            }
        }

        if (!errors.ClientMsgType && !errors.StartAt && !errors.EndAt) {
            for (let i = 0; i < filteredMessages.length; i++) {
                const message = filteredMessages[i];
                const messageStart = moment.unix(Number(message.StartAt) / 1000);
                const messageEnd = moment.unix(Number(message.EndAt) / 1000);

                if (endDate.valueOf() >= messageStart.valueOf() && endDate.valueOf() <= messageEnd.valueOf()) {
                    errors.EndAt = `
                        End time falls within another message. Please move end time before
                        ${formatMomentDateTime(messageStart, validationMessageDateFormat)} or move the
                        start time to after ${formatMomentDateTime(messageEnd, validationMessageDateFormat)}`;
                    break;
                }

                if (startDate.valueOf() <= messageStart.valueOf() && endDate.valueOf() >= messageEnd.valueOf()) {
                    errors.EndAt = `
                        Message completely overlaps another that starts at
                        ${formatMomentDateTime(messageStart, validationMessageDateFormat)}
                        and ends at ${formatMomentDateTime(messageEnd, validationMessageDateFormat)}`;
                    break;
                }
            }
        }
    }

    if (actionType === ActionTypes.edit && editMessage &&
        values.ClientMsgType === editMessage.ClientMsgType &&
        values.Message === editMessage.Message &&
        startDate.valueOf()
            .toString() === editMessage.StartAt &&
            endDate.valueOf()
                .toString() === editMessage.EndAt) {
        errors.Message = 'A field must edited to submit changes to message';
    }

    return errors;
};